<mat-sidenav-container>
  <mat-sidenav mode="side" gaCategory="sidebar_interactions" [(opened)]="opened" #sidenav>
    <m4s-visualizer-menu [visualizations]="visualizations" [selectedVisualization]="selectedVisualization"
                         [datasets]="(datasets$ | async) ?? []" [selectedDataset]="selectedDataset"
                         (visualizationSelected)="setSelectedVisualization($event)"
                         (datasetSelected)="setSelectedDataset($event)" (datasetSearched)="searchDataset($event)"
                         (datasetSearchCleared)="clearDatasetSearch()">
    </m4s-visualizer-menu>
  </mat-sidenav>

  <mat-sidenav-content>
    <p class="toggle" gaCategory="sidebar_toggle_interactions">
      <button mat-button gaEvent="opened" (click)="sidenav.toggle(); toggle()" [class.hidden]="opened">
        <mat-icon aria-hidden="false" aria-label="Open side drawer">
          arrow_right
        </mat-icon>
      </button>

      <button mat-button gaEvent="closed" (click)="sidenav.toggle(); toggle()" [class.hidden]="!opened">
        <mat-icon aria-hidden="false" aria-label="Close side drawer">
          arrow_left
        </mat-icon>
      </button>
    </p>

    <m4s-visualizer-content [visualization]="selectedVisualization" [datasets]="selectedDataset"
                            [search]="datasetSearch">
    </m4s-visualizer-content>
  </mat-sidenav-content>
</mat-sidenav-container>
